import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import StoreChangeWrapper, { ChangeStoreLinkText } from '../styles/ChangeStoreLink.styles';

const ChangeStoreLink = ({
  storeChangeText,
  bopisFilterLabels,
  handleChangeStoreOnKeyPress,
  handleChangeStoreLinkClick,
}) => {
  return (
    <StoreChangeWrapper className="store-change-wrapper">
      <ChangeStoreLinkText
        className={`change-store-link ${
          storeChangeText === bopisFilterLabels?.lbl_plp_select_store && 'select-store'
        }`}
        role="button"
        tabIndex="0"
        onKeyDown={handleChangeStoreOnKeyPress}
        onClick={() => handleChangeStoreLinkClick()}
        underline
        noLink={false}
      >
        <BodyCopy fontSize={['fs14']} fontFamily="secondary" color="blue.1300">
          {storeChangeText}
        </BodyCopy>
      </ChangeStoreLinkText>
    </StoreChangeWrapper>
  );
};

export default ChangeStoreLink;

ChangeStoreLink.propTypes = {
  storeChangeText: PropTypes.string.isRequired,
  bopisFilterLabels: PropTypes.shape({
    lbl_plp_select_store: PropTypes.string.isRequired,
  }).isRequired,
  handleChangeStoreOnKeyPress: PropTypes.func,
  handleChangeStoreLinkClick: PropTypes.func,
};

ChangeStoreLink.defaultProps = {
  handleChangeStoreOnKeyPress: () => {},
  handleChangeStoreLinkClick: () => {},
};
